import { Component } from 'react';
import { PoolTypography } from '@synergy/components';
import { Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';
import { connect } from 'react-redux';

import { AppState } from '../../../store/models/app-state';
import { ConvertReceiptTransitionsItem } from './convert-receipt-transition-item';
import { TransitionActivity } from '../../../common/models/transition-activity';
import { TransitionSource } from '../models/type-transition-source';
import { geDocumentTypeFromString } from '../../../common/utils/get-document-type-from-string';
import { getDocumentTypeFromSource } from '../util/get-document-type-from-source';

const styles = (theme: Theme) =>
    createStyles({
        container: {
            paddingLeft: theme.spacing(3),
            marginBottom: '16px',
        },
    });
interface ConvertReceiptTransitionsOwnProps {
    source: TransitionSource;
}

interface ConvertReceiptTransitionsReduxProps extends WithStyles<typeof styles> {
    transitionActivities: TransitionActivity[] | null;
}

type ConvertReceiptTransitionsProps = ConvertReceiptTransitionsOwnProps & ConvertReceiptTransitionsReduxProps;

class ConvertReceiptTransitionsBase extends Component<ConvertReceiptTransitionsProps> {
    public render() {
        const { classes, transitionActivities, source } = this.props;

        if (!transitionActivities) {
            return null;
        }

        const sourceDocumentType = getDocumentTypeFromSource(source);
        if (sourceDocumentType === null) {
            return null;
        }

        const transitionsWithoutSource = transitionActivities.filter(
            transitionActivity =>
                !(
                    transitionActivity.toId === source.id &&
                    geDocumentTypeFromString(transitionActivity.toType) === sourceDocumentType
                )
        );

        if (transitionsWithoutSource.length === 0) {
            return null;
        }

        const sorted = transitionsWithoutSource.sort((a, b) => {
            if (a.toType === b.toType) {
                return a.toId - b.toId;
            }
            return a.toType > b.toType ? 1 : -1;
        });

        return (
            <div className={classes.container}>
                <PoolTypography styleType="sectionTitle" id="app.convertReceipt.transitions" />
                {sorted.map(transitionActivity => (
                    <ConvertReceiptTransitionsItem
                        key={transitionActivity.id}
                        transitionActivity={transitionActivity}
                    />
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    transitionActivities: state.transitionActivities.flat,
});

const ConnectedConvertReceiptTransitions = connect(mapStateToProps, {})(ConvertReceiptTransitionsBase);

export const ConvertReceiptTransitions = withStyles(styles)(ConnectedConvertReceiptTransitions);
